import React from 'react'
import { View, StyleSheet } from 'react-native'
import { BackHeader, IconCloseCross, LogoDark } from '../../../../assets/icons'
import RootStore from '../../../../store'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import { isWeb } from '../../../../utils/helpers/commonUtils'
import { useResponsive } from '../../../../utils/hooks'
import cookies from '../../../../utils/service/cooker'
import { BtText } from '@linqpal/components/src/ui'
import { Spacer } from '../../../../ui/atoms'
import { paths } from '../../../links'
import { SingleVendor } from '../../PayablesTab/Store/VendorsStore'

export default function Toolbar({ company, navigation }) {
  const { userStore, branding } = RootStore
  const singleVendorStore = SingleVendor
  const isUserAuthenticated = isWeb
    ? !!cookies.get('session')
    : userStore.isAuthenticated

  const { screenWidth, sm } = useResponsive()

  return (
    <View style={[styles.header, { marginBottom: screenWidth > 450 ? 20 : 0 }]}>
      {isUserAuthenticated ? (
        <GetIcon
          icon={<BackHeader height="20" width="20" />}
          onPress={() => {
            singleVendorStore.resetVendor()
            if (navigation.canGoBack()) {
              navigation.goBack()
            } else {
              navigation.replace(paths.Home._self, {
                screen: paths.Console.Payables._self,
                params: {
                  screen: paths.Console.Payables.home,
                },
              })
            }
          }}
        />
      ) : sm && !branding ? (
        <LogoDark width={160} />
      ) : (
        <GetIcon
          icon={<IconCloseCross height="16" width="16" />}
          onPress={() => {
            singleVendorStore.resetVendor()
            navigation.replace(paths.Console._self)
          }}
        />
      )}
      <BtText
        style={{
          fontWeight: '600',
          fontSize: 18,
          marginLeft: 10,
          flex: 1,
          textAlign: 'center',
        }}
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {company?.name || company?.legalName}
      </BtText>
      <Spacer width={isUserAuthenticated ? 40 : sm && !branding ? 160 : 40} />
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    height: 64,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    justifyContent: 'space-between',
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E6EBEE',
    elevation: 1,
  },
})
